import React from 'react';
import Location from './Location';
import { locationData } from '../data/locations';
import { HighlightedAxisProvider } from './HighlightedAxisContext';

export default function Overview() {
  return (
    <>
      <HighlightedAxisProvider>
        {locationData.map((location, idx) => {
          let xAxisPosition = 'none';
          if (idx === 0) {
            xAxisPosition = 'none';
          } else if (idx === locationData.length - 1) {
            xAxisPosition = 'bottom';
          }
          return (
            <Location
              key={location.name}
              location={location}
              xAxisPosition={xAxisPosition}
            />
          );
        })}
      </HighlightedAxisProvider>
    </>
  );
}
